$( document ).on('turbolinks:load', function() {

	$(".vote").on("click", ".downvote, .upvote", function(){
		var userproduct_id = $(this).parent().data("id"),
		 	user2_id = $(this).parent().data("id2"),
			is_upvote = $(this).hasClass("upvote");

	$.ajax({
		url: "/userproduct/vote",
		method: "POST",
		data: { userproduct_id: userproduct_id, user2_id: user2_id, upvote: is_upvote },
		sucess: function(){
			console.log("sucess..");
		}
	})
	});
});